var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35 8C9.66984 8 11.55 6.20937 11.55 4C11.55 1.79063 9.66984 0 7.35 0C5.03016 0 3.15 1.79063 3.15 4C3.15 6.20937 5.03016 8 7.35 8ZM10.29 9H9.74203C9.01359 9.31875 8.20312 9.5 7.35 9.5C6.49687 9.5 5.68969 9.31875 4.95797 9H4.41C1.97531 9 0 10.8813 0 13.2V14.5C0 15.3281 0.705469 16 1.575 16H13.125C13.9945 16 14.7 15.3281 14.7 14.5V13.2C14.7 10.8813 12.7247 9 10.29 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledUser);
export default __webpack_public_path__ + "static/media/filledUser.74565696.svg";
export { ForwardRef as ReactComponent };